import * as React from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";

const FormDatePicker = ({
  label,
  value,
  onChange,
  name,
  placeholder = "MM/DD/YYYY",
  minDate,
  maxDate,
  disabled = false,
  fullWidth = true,
  size = "small",
  ...rest
}) => {
  return (
    <div className="form-group mb-3">
      {label && (
        <label className="form-label fw-semibold mb-2">
          {label}
        </label>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={onChange}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          {...rest}
          slotProps={{
            textField: {
              name,
              size,
              fullWidth,
              placeholder,
              InputProps: {
                sx: {
                  height:40,
                  fontSize: 14,
                  fontFamily: "Montserrat, sans-serif",
                  backgroundColor: "#f5f7fa",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "0 14px",
                  "& .MuiInputAdornment-root": {
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  },
                },
              },
            },
            popper: {
              sx: {
                "& .MuiPaper-root": {
                  borderRadius: "12px",
                  boxShadow:
                    "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
                  border: "1px solid #e5e7eb",
                },
                "& .MuiPickersCalendarHeader-root": {
                  paddingLeft: "16px",
                  paddingRight: "16px",
                },
                "& .MuiPickersCalendarHeader-label": {
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#111827",
                },
                "& .MuiDayCalendar-weekDayLabel": {
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#6b7280",
                },
                "& .MuiPickersDay-root": {
                  fontSize: "14px",
                  color: "#111827",
                  "&:hover": {
                    backgroundColor: "#f5f7fa",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#3b82f6",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#2563eb",
                    },
                  },
                },
                "& .MuiPickersDay-today": {
                  border: "1px solid #e5e7eb",
                  backgroundColor: "transparent",
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default FormDatePicker;
